import React, { useState } from "react";

const ShareModal = ({ visible, onClose, onSend, bookmark }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  if (!visible) return null;

  const handleSend = () => {
    onSend(bookmark, email, message); // envía el bookmark + valores al padre
    onClose();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "8px",
          minWidth: "300px",
          textAlign: "center",
        }}
      >
        <h3>Compartir Bookmark</h3>
        <p>{bookmark?.nombre}</p>

        <input
          type="text"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ marginBottom: "10px", width: "100%", padding: "8px" }}
        />
        <input
          type="text"
          placeholder="Mensaje"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          style={{ marginBottom: "10px", width: "100%", padding: "8px" }}
        />

        <div>
          <button onClick={handleSend} style={{ marginRight: "10px" }}>
            Enviar
          </button>
          <button onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
